import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map, switchMap, tap } from 'rxjs/operators';
import { UserIdService } from '../../auth';
import { SearchAction } from '../../features/store/actions/search.actions';
import { DeliveryAddress, Pagination, ShipTosSearchParams } from '../../model';
import { ShipTosFacade } from '../facades';
import { UserActions } from '../store/actions';
import { ShipTosSelectors } from '../store/selectors/user.selectors';
import { SHIP_TOS, ShipTosSearchParamsState, StateWithUser } from '../store/user-state';

@Injectable()
export class ShipTosService implements ShipTosFacade {
  constructor(private store: Store<StateWithUser>, private userIdService: UserIdService) {}

  searchForShipTos(searchParams: ShipTosSearchParams): void {
    this.userIdService.takeUserId(true).subscribe((userId) => {
      this.store.dispatch(new UserActions.LoadUserShipTos(searchParams, userId));
    });
  }

  getShipTos(): Observable<Array<DeliveryAddress>> {
    return this.store
      .select(ShipTosSelectors.getShipTosCombinedSearchPageResultsIdsSelector)
      .pipe(switchMap((results) => this.store.select(ShipTosSelectors.getShipTosSearchResultEntries, { keys: results })));
  }

  getShipTosLoading(): Observable<boolean> {
    return this.store
      .select(ShipTosSelectors.getShipTosSearchPageResultsSelector)
      .pipe(map((loaderState) => loaderState.loading));
  }

  getShipTosPagination(): Observable<Pagination | undefined> {
    return this.store.select(ShipTosSelectors.getShipTosSearchPaginationSelector);
  }

  getSearchParametersForShipTos(key: string = 'latest'): Observable<ShipTosSearchParamsState> {
    return this.store.select(ShipTosSelectors.getShipTosSearchParamsSelector).pipe(
      map((params) => params as ShipTosSearchParams),
      tap((params: ShipTosSearchParams) => {
        if (!params || !params.key) {
          const initialSearchParams: ShipTosSearchParams = {
            key: key,
            page: 0,
            count: 10,
          };

          this.updateSearchParametersForShipTos(initialSearchParams);
        }
      }),
      filter((params) => params && !!params.key)
    );
  }

  updateSearchParametersForShipTos(searchParams: ShipTosSearchParams) {
    this.store.dispatch(new SearchAction(searchParams, SHIP_TOS));
  }
}
